import { Site } from '@envato/foundation-types'

import { IItem } from '../../typings/searchResults'
import { toTitle } from '../utils/formatString'
import ga from '../utils/ga'
import { getCurrentSiteDomain } from '../utils/sites'

const getListName = (pageType: string): string => {
  if (pageType === 'category') {
    return 'Search Results: Category'
  }

  return 'Search Results: Search'
}

export const reportProductClick = ({
  index,
  item,
  currentSite,
  listName
}: {
  index: number
  item: Partial<IItem>
  currentSite: Site
  listName: string
}) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    brand: item.author_username,
    category: `${currentSiteDomain}/${item.classification}`,
    id: item.id,
    list: listName,
    name: item.name,
    position: index
  })
  ga('ec:setAction', 'click', {
    list: listName
  })
  ga('send', 'event', 'Ecommerce', 'click', 'Product click: product list')
}

export const reportProductAddToCartAttempt = ({
  item,
  index,
  currentSite,
  pageType
}: {
  item: Partial<IItem>
  index: number
  currentSite: Site
  pageType: string
}) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    brand: item.author_username,
    category: `${currentSiteDomain}/${item.classification}`,
    id: item.id,
    list: getListName(pageType),
    name: item.name,
    position: index
  })
  ga('ec:setAction', 'add')
  ga('send', 'event', 'Ecommerce', 'click', 'Add to cart: product list')
}

export const reportProductsImpressions = ({
  items,
  currentSite,
  itemRankOffset,
  page,
  section
}: {
  items: Partial<IItem>[]
  currentSite: Site
  itemRankOffset: number
  page?: string
  section?: string
}) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  const list =
    page && section
      ? `${page}: ${toTitle(section)}`
      : 'Product list name not specified'

  items.forEach((item, index) => {
    ga('ec:addImpression', {
      brand: item.author_username,
      category: `${currentSiteDomain}/${item.classification}`,
      id: item.id,
      list,
      name: item.name,
      position: index + itemRankOffset
    })
  })
  ga('send', 'event', 'Ecommerce', 'view', 'Product impression', {
    nonInteraction: true
  })
}

export const reportModalPageView = ({
  title,
  page
}: {
  title: string
  page: string
}) => {
  ga('send', {
    hitType: 'pageview',
    page,
    title
  })
}

export const reportAudioPreviewDownload = (id: any) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'audio player - search_cat page',
    eventAction: 'audio_download',
    eventLabel: `${id}`
  })
}

export const reportVideoPreviewDownload = (id: any) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'video player - search_cat page',
    eventAction: 'video_download',
    eventLabel: `${id}`
  })
}

export const reportAudioPlayClick = (id: any) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'audio player - search_cat page',
    eventAction: 'audio_start',
    eventLabel: `${id}`
  })
}
